const selectors = {
  tabList: '[data-mcc-product-tabs]',
  tabTrigger: '[data-mcc-tab-trigger]',
  tabPanel: '[data-mcc-tab-panel]',
  variantSummary: '[data-mcc-variant-summary]',
  shippingNoteText: '[data-mcc-shipping-note-text]',
  variantInventoryJson: '[data-mcc-variant-inventory]',
  variantTitleInput: '[data-mcc-variant-title-input]',
  customSizeForm: '[data-mcc-custom-size-form]',
  customSizeSuccess: '[data-mcc-custom-size-success]',
  customSizeTrigger: '[data-mcc-custom-size-trigger]',
  customSizeContent: '[data-mcc-custom-size-content]',
  slideshow: '.product-slideshow',
  slideControl: '[data-mcc-slide-control]',
  slideCounter: '[data-mcc-slide-counter]',
  slidePrev: '[data-mcc-slide-prev]',
  slideNext: '[data-mcc-slide-next]',
  pickupOpen: '[data-mcc-pickup-open]',
  pickupModal: '[data-mcc-pickup-modal]',
  pickupClose: '[data-mcc-pickup-close]',
  productImages: '[data-product-images]',
  colorImagesJson: '[data-mcc-color-images-json]',
  thumbScroller: '.product__thumbs--scroller',
  thumbSlider: '[data-product-thumbs]',
};

const customSizeFormStateStorageKey = 'mcc-custom-size-form-state';
const customSizeSubmittedFormStorageKey = 'mcc-custom-size-submitted-form-id';

const setPanelState = (trigger, panel, open) => {
  trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  trigger.classList.toggle('is-open', open);
  panel.hidden = !open;
};

const showSubmittedSuccess = (trigger, panel, success) => {
  panel.hidden = true;
  success.hidden = false;
  trigger.setAttribute('aria-expanded', 'true');
  trigger.classList.add('is-open');
};

const showSubmittedError = (trigger, panel, success) => {
  if (success) success.hidden = true;
  panel.hidden = false;
  trigger.setAttribute('aria-expanded', 'true');
  trigger.classList.add('is-open');
};

const applyCustomSizeFormState = (root, formId, status) => {
  const formRoot = root.querySelector(`[data-mcc-custom-size-form-id="${formId}"]`);
  if (!formRoot) return;

  const trigger = formRoot.querySelector(selectors.customSizeTrigger);
  const panel = formRoot.querySelector(selectors.customSizeContent);
  const success = formRoot.querySelector(selectors.customSizeSuccess);
  if (!trigger || !panel) return;

  if (status === 'success' && success) {
    showSubmittedSuccess(trigger, panel, success);
    return;
  }

  if (status === 'error') {
    showSubmittedError(trigger, panel, success);
  }
};

const getCurrentReturnUrl = () => `${window.location.pathname}${window.location.search}`;

const ensureFormReturnUrl = (form) => {
  let returnToInput = form.querySelector('input[name="return_to"]');
  if (!returnToInput) {
    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    form.appendChild(returnToInput);
  }

  returnToInput.value = getCurrentReturnUrl();
};

const readCustomSizeFormStatus = (productId, formId) => {
  const pdpProduct = document.querySelector(
    `mcc-product[data-product-id="${productId}"][data-modal="false"]`
  );
  const formRoot = pdpProduct?.querySelector(`[data-mcc-custom-size-form-id="${formId}"]`);
  return formRoot?.dataset.mccCustomSizeStatus || null;
};

const openQuickShopForProduct = (state, onReady) => {
  const { productId, productHandle } = state;
  const modalId = `QuickShopModal-${productId}`;
  const modal = document.getElementById(modalId);

  if (!modal) {
    onReady?.();
    return;
  }

  let readyCalled = false;
  const callReady = () => {
    if (readyCalled) return;
    readyCalled = true;
    onReady?.();
  };

  if (onReady) {
    const onLoaded = (evt) => {
      if (String(evt.detail?.productId) !== String(productId)) return;
      document.removeEventListener('quickview:loaded', onLoaded);
      window.requestAnimationFrame(callReady);
    };

    document.addEventListener('quickview:loaded', onLoaded);
    window.setTimeout(callReady, 4000);
  }

  const openBtn = document.querySelector(`.js-modal-open-quick-modal-${productId}`);
  const holder = document.getElementById(`QuickShopHolder-${productHandle}`);

  const openModal = () => {
    if (openBtn) {
      openBtn.click();
      return;
    }

    if (typeof theme?.Modals === 'function') {
      new theme.Modals(modalId, `quick-modal-${productId}`);
      document.querySelector(`.js-modal-open-quick-modal-${productId}`)?.click();
    }
  };

  const hasContent = holder?.querySelector('mcc-product, .product-section[data-product-handle]');

  if (!hasContent && typeof theme?.preloadProductModal === 'function') {
    const trigger = openBtn || document.createElement('button');
    theme.preloadProductModal(productHandle, productId, trigger);

    let attempts = 0;
    const waitForPreload = () => {
      attempts += 1;
      if (holder?.querySelector('mcc-product, .product-section[data-product-handle]') || attempts >= 60) {
        openModal();
        return;
      }
      window.setTimeout(waitForPreload, 100);
    };

    waitForPreload();
    return;
  }

  if (hasContent && typeof theme?.Modals === 'function' && openBtn?.classList.contains('btn--not-ready')) {
    new theme.Modals(modalId, `quick-modal-${productId}`);
  }

  openModal();
};

const consumeCustomSizeFormState = () => {
  let state = null;

  const rawState = window.sessionStorage.getItem(customSizeFormStateStorageKey);
  if (rawState) {
    try {
      state = JSON.parse(rawState);
    } catch (error) {
      state = null;
    }
    window.sessionStorage.removeItem(customSizeFormStateStorageKey);
  }

  const legacyFormId = window.localStorage.getItem(customSizeSubmittedFormStorageKey);
  if (!state?.formId && legacyFormId) {
    const pdpProduct = document.querySelector('mcc-product[data-modal="false"]');
    state = {
      formId: legacyFormId,
      productId: pdpProduct?.dataset.productId || null,
      productHandle: pdpProduct?.dataset.productHandle || null,
      openQuickShop: false,
    };
    window.localStorage.removeItem(customSizeSubmittedFormStorageKey);
  }

  if (!state?.formId) return;

  const status = readCustomSizeFormStatus(state.productId, state.formId) || 'success';
  const pdpProduct = document.querySelector(
    `mcc-product[data-product-id="${state.productId}"][data-modal="false"]`
  );

  if (pdpProduct) {
    applyCustomSizeFormState(pdpProduct, state.formId, status);
  }

  if (!state.openQuickShop || !state.productId || !state.productHandle) return;

  openQuickShopForProduct(state, () => {
    const modalProduct = document.querySelector(
      `mcc-product[data-product-id="${state.productId}"][data-modal="true"]`
    );
    if (modalProduct) {
      applyCustomSizeFormState(modalProduct, state.formId, status);
    }
  });
};

const runCustomSizeSubmissionFlow = () => {
  consumeCustomSizeFormState();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runCustomSizeSubmissionFlow, { once: true });
} else {
  runCustomSizeSubmissionFlow();
}

const refreshJudgemeCaches = (root = document) => {
  const $ = window.jdgm?.$;
  if (!$) return false;

  const $root = root === document ? $(document) : $(root);

  window.jdgm.caches = {
    $widgetWithReviews: $root.find('.jdgm-review-widget, .jdgm-revs-tab, .jdgm-all-reviews-widget'),
    $revWidgets: $root.find('.jdgm-review-widget, [data-widget="review"]'),
    $prevBadges: $root.find('.jdgm-preview-badge'),
  };

  return true;
};

const finalizeJudgemeBadges = (root = document) => {
  if (!window.jdgm) return false;

  refreshJudgemeCaches(root);

  const $ = window.jdgm.$;

  if ($) {
    const $root = root === document ? $(document) : $(root);
    $root.find('.jdgm-preview-badge').removeClass('jdgm--done-setup-widget jdgm--done-setup');
  }

  if (typeof window.jdgm.initializeWidgets === 'function' && $) {
    const initScope = root === document ? $('body') : $(root);

    try {
      window.jdgm.initializeWidgets(initScope);
    } catch (error) {
      console.warn('Judge.me initializeWidgets failed', error);
    }
  }

  if (typeof window.jdgm.customizeBadges === 'function') {
    window.jdgm.customizeBadges();
    return true;
  }

  return false;
};

const waitForJudgeme = (callback, attempt = 0) => {
  if (window.jdgm?.$ && typeof window.jdgm.customizeBadges === 'function') {
    callback();
    return;
  }

  if (attempt >= 50) return;

  window.setTimeout(() => waitForJudgeme(callback, attempt + 1), 100);
};

const normalizeColorLabel = (value) => {
  if (value == null) return '';
  return String(value).trim().toLowerCase();
};

const escapeHtml = (value) => {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

const buildColorSlideHtml = (imageData, index, { zoomEnabled, zoomIconSrc }) => {
  const main = imageData.main;
  const slideClass = index === 0 ? 'starting-slide' : 'secondary-slide';
  const imgClass = zoomEnabled ? 'photoswipe__image image-element' : 'image-element';
  const loading = 'eager';
  const paddingBottom = main.aspectRatio ? `${100 / main.aspectRatio}%` : '100%';

  const zoomButton = zoomEnabled
    ? `<button type="button" class="btn btn--body btn--circle js-photoswipe__zoom product__photo-zoom">
        ${
          zoomIconSrc
            ? `<img class="icon icon-zoom" src="${escapeHtml(zoomIconSrc)}" alt="" width="12" height="12" loading="lazy">`
            : `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><title>icon-search</title><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42"/></svg>`
        }
        <span class="icon__fallback-text">Zoom</span>
      </button>`
    : '';

  return `<div class="product-main-slide ${slideClass}" data-index="${index}">
    <div data-product-image-main class="product-image-main">
      <div class="image-wrap" style="height: 0; padding-bottom: ${paddingBottom};">
        <image-element>
          <img
            src="${escapeHtml(main.src)}"
            ${main.srcset ? `srcset="${escapeHtml(main.srcset)}"` : ''}
            ${main.width ? `width="${escapeHtml(main.width)}"` : ''}
            ${main.height ? `height="${escapeHtml(main.height)}"` : ''}
            class="${imgClass}"
            loading="${loading}"
            alt=""
            ${main.photoswipeSrc ? `data-photoswipe-src="${escapeHtml(main.photoswipeSrc)}"` : ''}
            ${main.photoswipeWidth ? `data-photoswipe-width="${escapeHtml(main.photoswipeWidth)}"` : ''}
            ${main.photoswipeHeight ? `data-photoswipe-height="${escapeHtml(main.photoswipeHeight)}"` : ''}
            data-index="${index + 1}"
            sizes="100vw">
        </image-element>
        ${zoomButton}
      </div>
    </div>
  </div>`;
};

const buildColorThumbHtml = (imageData, index) => {
  const thumb = imageData.thumb;
  const paddingBottom = thumb.aspectRatio ? `${100 / thumb.aspectRatio}%` : '100%';

  return `<div class="product__thumb-item" data-index="${index}">
    <a
      href="${escapeHtml(thumb.href || thumb.src)}"
      data-product-thumb
      class="product__thumb"
      data-index="${index}">
      <div class="image-wrap image-wrap__thumbnail" style="height: 0; padding-bottom: ${paddingBottom};">
        <img
          src="${escapeHtml(thumb.src)}"
          ${thumb.srcset ? `srcset="${escapeHtml(thumb.srcset)}"` : ''}
          ${thumb.width ? `width="${escapeHtml(thumb.width)}"` : ''}
          ${thumb.height ? `height="${escapeHtml(thumb.height)}"` : ''}
          class="image-element"
          loading="lazy"
          alt=""
          sizes="80px">
      </div>
    </a>
  </div>`;
};

class MccProduct extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };

    this._initTabs(options);
    this._initVariantSummary(options);
    this._initShippingNote(options);
    this._initCustomSizeForm(options);
    this._initColorImages(options);
    this._initSlideshowResize(options);
    this._initSlideControl(options);
    this._initPickupModal(options);
    this._initReviewsTrustText();
    this._initQuickShopModal(options);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this._reviewsTrustObserver?.disconnect();
    this.abortController.abort();
  }

  _initTabs(options) {
    const tabList = this.querySelector(selectors.tabList);
    if (!tabList) return;

    const triggers = Array.from(tabList.querySelectorAll(selectors.tabTrigger));
    const panels = Array.from(this.querySelectorAll(selectors.tabPanel));
    if (!triggers.length || !panels.length) return;

    const activateTab = (id) => {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.mccTabTrigger === id;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.mccTabPanel === id;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener(
        'click',
        () => {
          activateTab(trigger.dataset.mccTabTrigger);
        },
        options
      );
    });

    const initial =
      triggers.find((trigger) => trigger.classList.contains('is-active')) || triggers[0];

    if (initial) {
      activateTab(initial.dataset.mccTabTrigger);
    }
  }

  _initVariantSummary(options) {
    const summary = this.querySelector(selectors.variantSummary);
    if (!summary) return;

    const format = summary.dataset.mccMoneyFormat;
    const currency = summary.dataset.mccCurrency || '';

    const formatMoney = (cents) => {
      if (window.theme?.Currency?.formatMoney) {
        return window.theme.Currency.formatMoney(cents, format);
      }

      return (cents / 100).toFixed(2);
    };

    this.addEventListener(
      'variantChange',
      (evt) => {
        const variant = evt.detail?.variant;
        if (!variant) return;

        const parts = [formatMoney(variant.price) + (currency ? ` ${currency}` : '')];

        if (variant.title && variant.title !== 'Default Title') {
          parts.push(variant.title);
        }

        summary.textContent = parts.join(' · ');
      },
      options
    );
  }

  _initShippingNote(options) {
    const noteText = this.querySelector(selectors.shippingNoteText);
    if (!noteText) return;

    const inventoryJson = this.querySelector(selectors.variantInventoryJson);
    let inventoryById = {};

    try {
      inventoryById = inventoryJson ? JSON.parse(inventoryJson.textContent) : {};
    } catch (error) {
      inventoryById = {};
    }

    const resolveNote = (variant) => {
      const positive = noteText.dataset.mccShippingPositive || '';
      const negative = noteText.dataset.mccShippingNegative || '';
      const fallback = noteText.dataset.mccShippingFallback || '';
      const quantity = Number(inventoryById[variant?.id] ?? 0);

      if (quantity > 0) {
        return positive || fallback;
      }

      return negative || fallback;
    };

    this.addEventListener(
      'variantChange',
      (evt) => {
        const variant = evt.detail?.variant;
        if (!variant) return;

        noteText.textContent = resolveNote(variant);
      },
      options
    );
  }

  _initCustomSizeForm(options) {
    const formRoots = this.querySelectorAll(selectors.customSizeForm);

    formRoots.forEach((formRoot) => {
      const trigger = formRoot.querySelector(selectors.customSizeTrigger);
      const panel = formRoot.querySelector(selectors.customSizeContent);
      const form = formRoot.querySelector('form');
      const formId = formRoot.dataset.mccCustomSizeFormId;
      if (!trigger || !panel) return;

      trigger.addEventListener(
        'click',
        () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          setPanelState(trigger, panel, !isOpen);
        },
        options
      );

      form?.addEventListener(
        'submit',
        () => {
          if (!formId) return;

          ensureFormReturnUrl(form);

          const submittedFromModal = this.dataset.modal === 'true';

          window.sessionStorage.setItem(
            customSizeFormStateStorageKey,
            JSON.stringify({
              formId,
              productId: this.dataset.productId || null,
              productHandle: this.dataset.productHandle || null,
              openQuickShop: submittedFromModal,
            })
          );
        },
        options
      );
    });

    const variantInputs = this.querySelectorAll(selectors.variantTitleInput);
    if (!variantInputs.length) return;

    this.addEventListener(
      'variantChange',
      (evt) => {
        const variant = evt.detail?.variant;
        if (!variant) return;

        const title = variant.title === 'Default Title' ? '' : variant.title;

        variantInputs.forEach((input) => {
          input.value = title;
        });
      },
      options
    );
  }

  _initColorImages(options) {
    const imagesRoot = this.querySelector(selectors.productImages);
    if (!imagesRoot?.hasAttribute('data-mcc-color-images')) return;

    const jsonEl = this.querySelector(selectors.colorImagesJson);
    if (!jsonEl) return;

    let colorImages = [];
    try {
      colorImages = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(colorImages) || !colorImages.length) return;

    const colorOptionIndex = Number.parseInt(imagesRoot.dataset.colorOptionIndex, 10);
    if (Number.isNaN(colorOptionIndex)) return;

    const slideshow = imagesRoot.querySelector(selectors.slideshow);
    const thumbScroller = imagesRoot.querySelector(selectors.thumbScroller);
    const thumbSlider = imagesRoot.querySelector(selectors.thumbSlider);
    const slideControl = this.querySelector(selectors.slideControl);
    const slideCounter = slideControl?.querySelector(selectors.slideCounter);

    if (!slideshow) return;

    const galleryOptions = {
      zoomEnabled: this.dataset.modal !== 'true' && imagesRoot.dataset.zoom === 'true',
      zoomIconSrc: imagesRoot.dataset.mccZoomIcon || '',
    };

    const defaultSlidesTemplate = imagesRoot.querySelector('[data-mcc-default-slides]');
    const defaultThumbsTemplate = imagesRoot.querySelector('[data-mcc-default-thumbs]');
    const defaultSlidesHtml = defaultSlidesTemplate?.innerHTML.trim() || slideshow.innerHTML;
    const defaultThumbsHtml = defaultThumbsTemplate?.innerHTML.trim() || thumbScroller?.innerHTML || '';
    let activeColorLabel = null;

    const countSlides = () =>
      slideshow.querySelectorAll('.product-main-slide').length;

    const destroySlideshow = () => {
      const flickity = this._getFlickityInstance();
      if (flickity?.destroy) {
        flickity.destroy();
      }
    };

    const initSlideshow = (slideCount) => {
      if (slideCount <= 1) {
        const slide = slideshow.querySelector('.product-main-slide');
        slide?.classList.add('is-selected');
        return null;
      }

      const args = {
        dragThreshold: 25,
        adaptiveHeight: true,
        avoidReflow: true,
        initialIndex: 0,
        childNav: thumbSlider,
        childNavScroller: thumbScroller,
        childVertical: thumbSlider?.dataset.position === 'beside',
        pageDots: true,
        wrapAround: true,
      };

      const createSlideshow = () => {
        if (this._getFlickityInstance()) return;

        if (window.theme?.Slideshow) {
          return new window.theme.Slideshow(slideshow, args);
        }

        if (window.Flickity) {
          return new window.Flickity(slideshow, args);
        }

        return null;
      };

      const runSlideshowInit = () => {
        window.requestAnimationFrame(() => {
          createSlideshow();
          bindSlideControl();
          this._resizeSlideshow();
        });
      };

      if (this.dataset.modal === 'true') {
        const productId = this.dataset.productId;

        const isQuickShopOpen = () => {
          if (!productId) return false;
          const modal = document.getElementById(`QuickShopModal-${productId}`);
          return modal?.classList.contains('is-open') ?? false;
        };

        if (this._mccSlideshowModalReady || isQuickShopOpen()) {
          this._mccSlideshowModalReady = true;
          runSlideshowInit();
          return null;
        }

        const initWhenVisible = (evt) => {
          if (productId && evt?.detail?.productId != null) {
            if (String(evt.detail.productId) !== String(productId)) return;
          }

          this._mccSlideshowModalReady = true;
          runSlideshowInit();
        };

        if (productId) {
          document.addEventListener(`modalOpen.QuickShopModal-${productId}`, initWhenVisible, {
            once: true,
            signal: options.signal,
          });
        }

        document.addEventListener('quickview:open', initWhenVisible, {
          once: true,
          signal: options.signal,
        });

        return null;
      }

      return createSlideshow();
    };

    const updateSlideControl = (slideCount) => {
      if (!slideControl) return;

      if (slideCount <= 1) {
        slideControl.hidden = true;
        return;
      }

      slideControl.hidden = false;
      if (slideCounter) {
        slideCounter.textContent = `1/${slideCount}`;
      }
    };

    const bindSlideControl = (attempt = 0) => {
      if (!slideControl) return;

      const flickity = this._getFlickityInstance();
      if (!flickity) {
        if (attempt < 30) {
          window.setTimeout(() => bindSlideControl(attempt + 1), 100);
        }
        return;
      }

      const updateCounter = (index) => {
        if (!slideCounter) return;
        slideCounter.textContent = `${index + 1}/${countSlides()}`;
      };

      updateCounter(flickity.selectedIndex || 0);

      if (this._colorGalleryChangeHandler) {
        flickity.off('change', this._colorGalleryChangeHandler);
      }

      this._colorGalleryChangeHandler = (index) => updateCounter(index);
      flickity.on('change', this._colorGalleryChangeHandler);
    };

    const reinitPhotoswipe = () => {
      if (this.dataset.modal === 'true') return;

      const sectionId = this.dataset.sectionId;
      if (!sectionId || !window.theme?.Photoswipe) return;
      new window.theme.Photoswipe(imagesRoot, sectionId);
    };

    const updateGalleryChrome = (slideCount) => {
      imagesRoot.dataset.hasSlideshow = slideCount > 1 ? 'true' : 'false';
      thumbSlider?.classList.toggle('medium-up--hide', slideCount <= 1);
      updateSlideControl(slideCount);
    };

    const rebuildGallery = (images) => {
      destroySlideshow();

      if (!images?.length) {
        slideshow.innerHTML = defaultSlidesHtml;
        slideshow.removeAttribute('data-mcc-active-color');
        if (thumbScroller) {
          thumbScroller.innerHTML = defaultThumbsHtml;
        }
      } else {
        slideshow.innerHTML = images
          .map((imageData, index) => buildColorSlideHtml(imageData, index, galleryOptions))
          .join('');

        if (thumbScroller) {
          thumbScroller.innerHTML = images
            .map((imageData, index) => buildColorThumbHtml(imageData, index))
            .join('');
        }
      }

      const slideCount = countSlides();
      updateGalleryChrome(slideCount);

      initSlideshow(slideCount);
      bindSlideControl();
      reinitPhotoswipe();

      window.requestAnimationFrame(() => {
        this._resizeSlideshow();
        if (window.AOS) {
          window.AOS.refreshHard();
        }
      });
    };

    const findColorImages = (colorLabel) => {
      const normalized = normalizeColorLabel(colorLabel);
      if (!normalized) return null;

      const match = colorImages.find(
        (entry) => normalizeColorLabel(entry.color_label) === normalized
      );

      if (!match) return null;

      if (Array.isArray(match.images) && match.images.length) {
        return match.images;
      }

      if (match.main) {
        return [{ main: match.main, thumb: match.thumb }];
      }

      return null;
    };

    const colorOptionKey = `option${colorOptionIndex + 1}`;

    const applyColorGallery = (colorLabel) => {
      const normalized = normalizeColorLabel(colorLabel);
      const images = findColorImages(colorLabel);

      if (images?.length) {
        if (activeColorLabel !== normalized) {
          activeColorLabel = normalized;
          rebuildGallery(images);
          slideshow.dataset.mccActiveColor = colorLabel;
        }
        return;
      }

      if (activeColorLabel !== null) {
        activeColorLabel = null;
        rebuildGallery(null);
      }
    };

    const getSelectedColor = (evt) => {
      const values = evt?.detail?.currentlySelectedValues;
      if (Array.isArray(values)) {
        const colorEntry = values.find((entry) => entry?.index === colorOptionKey);
        if (colorEntry?.value != null) return colorEntry.value;
      }

      const checkedSwatch = this.querySelector(
        `.variant__input--color-swatch[data-color-index="${colorOptionIndex}"]:checked`
      );
      if (checkedSwatch?.value) return checkedSwatch.value;

      if (imagesRoot.dataset.initialColor) return imagesRoot.dataset.initialColor;

      const variantJson = this.querySelector('[data-current-variant-json]');
      if (variantJson) {
        try {
          const variant = JSON.parse(variantJson.textContent);
          return variant[colorOptionKey] || '';
        } catch (error) {
          // Ignore malformed variant JSON.
        }
      }

      return '';
    };

    const bindExistingGallery = () => {
      const slideCount = countSlides();
      updateGalleryChrome(slideCount);
      initSlideshow(slideCount);
      bindSlideControl();
    };

    const startColorGallery = () => {
      const selectedColor = getSelectedColor();
      const images = findColorImages(selectedColor);
      const normalized = normalizeColorLabel(selectedColor);
      const renderedColor = normalizeColorLabel(slideshow.dataset.mccActiveColor);

      if (images?.length) {
        activeColorLabel = normalized;

        if (renderedColor === normalized && slideshow.querySelector('.product-main-slide')) {
          bindExistingGallery();
          return;
        }

        rebuildGallery(images);
        slideshow.dataset.mccActiveColor = selectedColor;
        return;
      }

      bindExistingGallery();
    };

    const finalizeGalleryControls = () => {
      bindSlideControl();
    };

    this.addEventListener(
      'variantChange',
      (evt) => {
        const changedOption = evt.detail?.index;
        if (changedOption && changedOption !== colorOptionKey) return;

        applyColorGallery(getSelectedColor(evt));
      },
      options
    );

    startColorGallery();

    finalizeGalleryControls();
    document.addEventListener('page:loaded', finalizeGalleryControls, {
      once: true,
      signal: options.signal,
    });
  }

  _resizeSlideshow() {
    const slideshow = this.querySelector(`${selectors.slideshow}.flickity-enabled`);
    if (!slideshow) return;

    const flickityInstance =
      slideshow.flickity || (window.Flickity && window.Flickity.data(slideshow));

    if (flickityInstance && typeof flickityInstance.resize === 'function') {
      flickityInstance.resize();
    }
  }

  _initSlideshowResize(options) {
    const mediaCol = this.querySelector('.mcc-product__media-col');
    if (!mediaCol || typeof ResizeObserver === 'undefined') return;

    const resize = () => {
      window.requestAnimationFrame(() => {
        this._resizeSlideshow();
      });
    };

    this.resizeObserver = new ResizeObserver(resize);
    this.resizeObserver.observe(mediaCol);

    window.addEventListener('resize', resize, options);

    document.addEventListener(
      'page:loaded',
      () => {
        window.setTimeout(resize, 100);
      },
      options
    );

    window.setTimeout(resize, 300);
  }

  _getFlickityInstance() {
    const slideshow = this.querySelector(selectors.slideshow);
    if (!slideshow) return null;

    if (window.Flickity) {
      return window.Flickity.data(slideshow);
    }

    return slideshow.flickity || null;
  }

  _bindSlideNavButtons(control, options) {
    if (!control || control.dataset.mccSlideNavBound === 'true') return;
    control.dataset.mccSlideNavBound = 'true';

    const prevBtn = control.querySelector(selectors.slidePrev);
    const nextBtn = control.querySelector(selectors.slideNext);

    prevBtn?.addEventListener(
      'click',
      () => {
        const flickity = this._getFlickityInstance();
        if (flickity) flickity.previous();
      },
      options
    );

    nextBtn?.addEventListener(
      'click',
      () => {
        const flickity = this._getFlickityInstance();
        if (flickity) flickity.next();
      },
      options
    );
  }

  _initSlideControl(options) {
    const control = this.querySelector(selectors.slideControl);
    if (!control) return;

    this._bindSlideNavButtons(control, options);

    const imagesRoot = this.querySelector(selectors.productImages);
    if (imagesRoot?.hasAttribute('data-mcc-color-images')) return;

    const counter = control.querySelector(selectors.slideCounter);
    const slideshow = this.querySelector(selectors.slideshow);
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('.product-main-slide');
    if (slides.length <= 1) return;

    const updateCounter = (index) => {
      if (!counter) return;
      counter.textContent = `${index + 1}/${slides.length}`;
    };

    const bindFlickity = (attempt = 0) => {
      const flickity = this._getFlickityInstance();

      if (!flickity) {
        if (attempt < 30) {
          window.setTimeout(() => bindFlickity(attempt + 1), 100);
        }
        return;
      }

      control.hidden = false;
      updateCounter(flickity.selectedIndex);

      flickity.on('change', (index) => {
        updateCounter(index);
      });
    };

    bindFlickity();
  }

  _injectReviewsTrustText(text) {
    this.querySelectorAll('.jdgm-preview-badge').forEach((widget) => {
      if (widget.querySelector('[data-mcc-reviews-trust]')) return;

      const badge = widget.querySelector('.jdgm-prev-badge');
      if (!badge?.querySelector('.jdgm-star')) return;

      if (window.getComputedStyle(badge).display === 'none') return;

      widget.classList.add('mcc-product__reviews-row');

      const trustEl = document.createElement('span');
      trustEl.className = 'mcc-product__reviews-trust';
      trustEl.setAttribute('data-mcc-reviews-trust', '');
      trustEl.textContent = text;
      widget.appendChild(trustEl);
    });
  }

  _initReviewsTrustText() {
    const text = this.dataset.mccReviewsTrustText;
    if (!text) return;

    const setupBadges = (full = true) => {
      if (full) {
        finalizeJudgemeBadges(this);
      } else if (typeof window.jdgm?.customizeBadges === 'function') {
        refreshJudgemeCaches(this);
        window.jdgm.customizeBadges();
      }

      this._injectReviewsTrustText(text);
    };

    waitForJudgeme(() => setupBadges(true));

    if (this._reviewsTrustObserver) return;

    this._reviewsTrustObserver = new MutationObserver(() => {
      if (!this.querySelector('.jdgm-preview-badge')) return;

      waitForJudgeme(() => setupBadges(false));
    });

    this._reviewsTrustObserver.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  _initQuickShopModal(options) {
    if (this.dataset.modal !== 'true') return;

    this.classList.add('is-modal');

    const productId = this.dataset.productId;
    if (!productId) return;

    const refreshLazyBlocks = () => {
      this._initTabs(options);
      this._initVariantSummary(options);
      this._initShippingNote(options);
      this._initCustomSizeForm(options);
      this._initReviewsTrustText();
    };

    document.addEventListener(
      'quickview:loaded',
      (evt) => {
        if (String(evt.detail?.productId) !== String(productId)) return;
        refreshLazyBlocks();
      },
      options
    );

    const resizeOnOpen = () => {
      window.requestAnimationFrame(() => {
        this._resizeSlideshow();
      });
    };

    document.addEventListener(`modalOpen.QuickShopModal-${productId}`, resizeOnOpen, options);

    document.addEventListener(
      'quickview:open',
      (evt) => {
        if (String(evt.detail?.productId) !== String(productId)) return;
        resizeOnOpen();
      },
      options
    );
  }

  _initPickupModal(options) {
    const modal = this.querySelector(selectors.pickupModal);
    if (!modal || this._pickupModalInitialized) return;

    this._pickupModalInitialized = true;

    let lastFocusedElement = null;

    const closeButtons = modal.querySelectorAll(selectors.pickupClose);

    const openModal = (evt) => {
      evt?.preventDefault();
      evt?.stopPropagation();

      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.documentElement.classList.add('mcc-pickup-modal-open');

      if (this.dataset.modal === 'true' && modal.parentElement !== document.body) {
        this._pickupModalPlaceholder = document.createComment('mcc-pickup-modal-placeholder');
        modal.parentElement.insertBefore(this._pickupModalPlaceholder, modal);
        document.body.appendChild(modal);
      }

      const closeBtn = modal.querySelector('.mcc-pickup-modal__close');
      if (closeBtn) closeBtn.focus();
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mcc-pickup-modal-open');

      if (this._pickupModalPlaceholder?.parentNode) {
        this._pickupModalPlaceholder.parentNode.insertBefore(modal, this._pickupModalPlaceholder);
        this._pickupModalPlaceholder.remove();
        this._pickupModalPlaceholder = null;
      }

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    };

    this.addEventListener(
      'click',
      (evt) => {
        const trigger = evt.target.closest(selectors.pickupOpen);
        if (!trigger || !this.contains(trigger)) return;
        openModal(evt);
      },
      options
    );

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', closeModal, options);
    });

    document.addEventListener(
      'keydown',
      (evt) => {
        if (evt.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      },
      options
    );
  }
}

if (!customElements.get('mcc-product')) {
  customElements.define('mcc-product', MccProduct);
}
